import { Button } from "@progress/kendo-react-buttons";
import { CSSProperties, ReactNode } from "react";

type Props = {
  width?: CSSProperties["width"];
  isReadOnly?: boolean | undefined;
  themeColor?:
    | null
    | "base"
    | "primary"
    | "secondary"
    | "tertiary"
    | "info"
    | "success"
    | "warning"
    | "error"
    | "dark"
    | "light"
    | "inverse";
  onClick: () => void;
  children: ReactNode;
};

export const StyledButton = ({
  width = "100%",
  isReadOnly = false,
  themeColor = "base",
  onClick,
  children,
}: Props) => {
  return (
    <Button
      style={{ width, opacity: isReadOnly ? 0.5 : 1, pointerEvents: isReadOnly ? "none" : "auto" }}
      themeColor={themeColor}
      onClick={() => onClick()}
    >
      {children}
    </Button>
  );
};
